<a
  [href]="issueUrl()"
  target="_blank"
  class="jira-issue-link"
>
  <strong>{{ fieldValue() }}</strong>
</a>
